import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../index.css";
import logo from "../img/logo.png";
// import { useState } from "react";
import { FaBars } from "react-icons/fa";

const AppBar = () => {
  // const navRef = useRef();
  const [isMobile, setIsMobile] = useState(false);
  return (
    <>
      <section className="nav-container">
        <div className="upper-nav">
          <span className="upper-nav-span">
            <span>
              <i class="fa-solid fa-location-dot nav-icon"></i>
              <p className="nav-location">
                House #77 Model Town NepalPur, 54000
              </p>
            </span>
            <span>
              <i class="fa-solid fa-envelope nav-icon"></i>
              <p className="nav-mail">info@docfind.com</p>
            </span>
          </span>
          <li className="nav-account">
            <i class="fa-solid fa-user nav-icon"></i>
            Account
            <ul className="login-dropdown">
              <li>
                <Link to="/login">
                  <i class="fa-solid fa-right-to-bracket account-icon"></i>Log
                  In
                </Link>
              </li>
              <hr className="account-hr" />
              <li>
                <Link to="/signUp">
                  <i class="fa-solid fa-user-plus account-icon"></i>Sign Up
                </Link>
              </li>
            </ul>
          </li>
        </div>
      </section>

      <nav className="lower-nav navbar">
        <img src={logo} alt="logo" className="logo" />
        <ul
          className={isMobile ? "nav-links-mobile" : "nav-links"}
          onClick={() => setIsMobile(false)}
        >
          <li>
            <Link to="/" className="menu-items-li home">
              Home
            </Link>
          </li>
          <li>
            <Link to="/doctors" className="menu-items-li doctor">
              Doctors
            </Link>
          </li>
          <li>
            <Link to="/about" className="menu-items-li about">
              About
            </Link>
          </li>
          <li>
            <Link to="/news" className="menu-items-li">
              News <i class="fa-solid fa-caret-down arrow-down"></i>
            </Link>
            <ul className="dropdown-nav">
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/services" className="menu-items-li">
              Services
            </Link>
          </li>
          <li>
            <Link to="/contact" className="menu-items-li">
              Contact
            </Link>
          </li>
          <li>
            <Link to="/doctors" className="find-doc">
              Find A Doctor +
            </Link>
          </li>
        </ul>
        <button
          className="mobile-menu-icon"
          onClick={() => setIsMobile(!isMobile)}
        >
          {isMobile ? (
            <i className="fas fa-times"></i>
          ) : (
            <i className="fas fa-bars"></i>
          )}
        </button>
      </nav>
    </>
  );
};

export default AppBar;
